import React, { useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { getRole } from "../api/user";
import Sidebar from "../Components/Dashboard/Sidebar";
import { AuthContext } from "../contexts/AuthProvider";

const DashboardLayout = () => {
  const { user } = useContext(AuthContext);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

useEffect(() => {
  if (!user?.email) {
    setLoading(false);
    return;
  }

  const token = localStorage.getItem("aircnc-token");
  if (!token) {
    setLoading(false);
    return;
  }

  setLoading(true);

  getRole(user.email)
    .then(data => {
      setRole(data);
    })
    .catch(console.error)
    .finally(() => {
      setLoading(false);
    });

}, [user?.email]);


  if (loading) return null;


  return (
    <div className="flex flex-row relative">
      <div className="lg:w-[300px] md:w-[100px] sticky top-0 self-start min-h-screen">
        <Sidebar role={role} />
      </div>

      <div className="w-full h-screen overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
